(function () {
  var root = document.getElementById('LaunchNotify');
  if (!root) return;

  var form = root.querySelector('[data-launch-notify-form]');
  var errorEl = root.querySelector('[data-launch-notify-error]');
  var successEl = root.querySelector('[data-launch-notify-success]');
  var successTextEl = root.querySelector('[data-launch-notify-success-text]');
  var submitBtn = root.querySelector('[data-launch-notify-submit]');
  var copyEl = root.querySelector('[data-launch-notify-copy]');
  var eyebrowEl = root.querySelector('[data-launch-notify-eyebrow]');
  var titleEl = root.querySelector('[data-launch-notify-title]');
  var thumbEl = root.querySelector('[data-launch-notify-thumb]');
  var nameInput = root.querySelector('#LaunchNotifyName');
  var emailInput = root.querySelector('#LaunchNotifyEmail');
  var lengthListEl = root.querySelector('[data-launch-notify-lengths]');
  var companyId = (root.getAttribute('data-klaviyo-company-id') || '').trim();
  var context = { handle: '', title: '', url: '', mode: 'restock', product: null, variantIds: [], lengthLabel: '' };
  var implicitIds = [];
  var submitting = false;
  var succeeded = false;
  var closeTimer = null;
  var fadeTimer = null;
  var SUBMIT_LABEL = 'Notify Me';
  var SUCCESS_LABEL = 'Subscribed ✓';
  var CLOSE_MS = 5000;
  var FADE_MS = 250;

  var COPY = {
    coming_soon: {
      eyebrow: 'Coming Soon',
      title: 'Get notified at launch',
      success: 'You’re on the list. We’ll email you when it launches.',
      verb: 'is available to order'
    },
    restock: {
      eyebrow: 'Back in stock',
      title: 'Notify me when it’s back',
      success: 'You’re on the list. We’ll email you when it’s back in stock.',
      verb: 'is back in stock'
    }
  };

  function configured() {
    return !!companyId;
  }

  function copyFor(mode) {
    return COPY[mode] || COPY.restock;
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function showError(msg) {
    if (!errorEl) return;
    errorEl.textContent = msg || '';
    errorEl.hidden = !msg;
  }

  function clearCloseTimers() {
    if (closeTimer) {
      clearTimeout(closeTimer);
      closeTimer = null;
    }
    if (fadeTimer) {
      clearTimeout(fadeTimer);
      fadeTimer = null;
    }
    root.classList.remove('is-leaving');
  }

  function setOpen(open) {
    if (!open) clearCloseTimers();
    root.hidden = !open;
    root.classList.toggle('is-open', open);
    if (!open) root.classList.remove('is-leaving');
    document.body.classList.toggle('launch-notify-open', open);
    if (open && nameInput) nameInput.focus();
  }

  function resetForm() {
    succeeded = false;
    clearCloseTimers();
    if (nameInput) nameInput.disabled = false;
    if (emailInput) emailInput.disabled = false;
    if (submitBtn) {
      submitBtn.hidden = false;
      submitBtn.disabled = false;
      submitBtn.classList.remove('is-subscribed', 'is-selection-disabled');
      submitBtn.textContent = SUBMIT_LABEL;
    }
    if (successEl) successEl.hidden = true;
    showError('');
  }

  function parseJsonEl(el) {
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (err) {
      return null;
    }
  }

  function productFromTrigger(trigger) {
    if (!trigger) return null;
    var card = trigger.closest('.product-card');
    if (card) {
      var fromCard = parseJsonEl(card.querySelector('.product-card__data'));
      if (fromCard) return fromCard;
    }
    if (trigger.closest('#quick-shop') && window.SHHQuickShop && typeof SHHQuickShop.getProduct === 'function') {
      return SHHQuickShop.getProduct();
    }
    return parseJsonEl(document.querySelector('[data-pdp-buy-box-data]'));
  }

  function getProduct() {
    if (context.product && context.product.variants) return context.product;
    return parseJsonEl(document.querySelector('[data-pdp-buy-box-data]'));
  }

  function isDefaultTitle(title) {
    return !title || /^default title$/i.test(String(title).trim());
  }

  function lengthOptionKey(product) {
    var idx = product && product.length_option_index;
    if (idx === null || idx === undefined) {
      var options = (product && product.options) || [];
      for (var i = 0; i < options.length; i++) {
        var name = String(options[i] == null ? '' : options[i]).toLowerCase();
        if (name === 'length' || name === 'variant') {
          idx = i;
          break;
        }
      }
    }
    if (idx === null || idx === undefined) return null;
    return 'option' + (Number(idx) + 1);
  }

  function variantLengthLabel(variant, product) {
    if (!variant) return '';
    var key = lengthOptionKey(product);
    var fromOption = key ? String(variant[key] || '').trim() : '';
    if (fromOption && !isDefaultTitle(fromOption)) return fromOption;
    var fromOption1 = String(variant.option1 || '').trim();
    if (fromOption1 && !isDefaultTitle(fromOption1)) return fromOption1;
    var title = String(variant.title || '').trim();
    if (!isDefaultTitle(title)) return title;
    return '';
  }

  function soldOutLengths(product, mode) {
    var variants = (product && product.variants) || [];
    var groups = {};
    var order = [];
    var comingSoon = mode === 'coming_soon';
    for (var i = 0; i < variants.length; i++) {
      var variant = variants[i];
      var label = variantLengthLabel(variant, product);
      if (!label) continue;
      if (!groups[label]) {
        groups[label] = { label: label, ids: [], available: false };
        order.push(label);
      }
      if (variant.available && !comingSoon) {
        groups[label].available = true;
      } else {
        groups[label].ids.push(String(variant.id));
      }
    }
    var list = [];
    for (var j = 0; j < order.length; j++) {
      var group = groups[order[j]];
      if (!group.available && group.ids.length) list.push(group);
    }
    return list;
  }

  function unavailableLengthLabels(product) {
    return soldOutLengths(product, context.mode).map(function (group) {
      return group.label;
    });
  }

  function isPartialSellout(product) {
    var variants = (product && product.variants) || [];
    if (variants.length < 2) return false;
    var anyAvail = false;
    var anyOos = false;
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].available) anyAvail = true;
      else anyOos = true;
    }
    return anyAvail && anyOos;
  }

  function parseVariantIds(opts, trigger) {
    var raw = [];
    if (opts && opts.variantIds && opts.variantIds.length) {
      raw = opts.variantIds;
    } else if (opts && opts.variantId != null && opts.variantId !== '') {
      raw = String(opts.variantId).split(',');
    } else if (trigger) {
      var attr = trigger.getAttribute('data-launch-variant');
      if (attr) raw = attr.split(',');
    }
    var ids = [];
    var seen = {};
    raw.forEach(function (value) {
      var id = String(value == null ? '' : value).trim();
      if (!id || seen[id]) return;
      seen[id] = true;
      ids.push(id);
    });
    return ids;
  }

  function scopedLengthLabel(product, ids) {
    if (!ids.length || !product) return '';
    var idSet = {};
    ids.forEach(function (id) { idSet[String(id)] = true; });
    var variants = product.variants || [];
    for (var i = 0; i < variants.length; i++) {
      if (!idSet[String(variants[i].id)]) continue;
      var label = variantLengthLabel(variants[i], product);
      if (label) return label;
    }
    return '';
  }

  function listIsVisible() {
    return !!(lengthListEl && !lengthListEl.hidden);
  }

  function buildCopyHtml(pack, product) {
    var title = (context.title || (product && product.title) || '').trim();
    var nameHtml = title
      ? '<span class="launch-notify__product">' + escapeHtml(title) + '</span>'
      : 'this product';
    var html = '<span class="launch-notify__copy-main">We’ll email you when ' + nameHtml + ' ' + pack.verb + '.</span>';
    if (!listIsVisible() && !context.variantIds.length && isPartialSellout(product)) {
      var lengths = unavailableLengthLabels(product);
      if (lengths.length > 1) {
        html += '<span class="launch-notify__lengths">Currently unavailable in ' + escapeHtml(lengths.join(', ')) + '.</span>';
      }
    }
    return html;
  }

  function selectedVariantIds() {
    if (listIsVisible()) {
      var ids = [];
      var seen = {};
      Array.prototype.forEach.call(lengthListEl.querySelectorAll('input[type="checkbox"]:checked'), function (cb) {
        String(cb.value || '').split(',').forEach(function (raw) {
          var id = String(raw || '').trim();
          if (!id || seen[id]) return;
          seen[id] = true;
          ids.push(id);
        });
      });
      return ids;
    }
    return implicitIds.slice();
  }

  function unavailableCatalogIds() {
    return selectedVariantIds().map(function (id) {
      return '$shopify:::$default:::' + id;
    });
  }

  function isTriggerLength(group) {
    if (context.lengthLabel && group.label === context.lengthLabel) return true;
    if (!context.variantIds.length) return false;
    var idSet = {};
    context.variantIds.forEach(function (id) { idSet[String(id)] = true; });
    return group.ids.some(function (id) { return idSet[id]; });
  }

  function clearLengthList() {
    implicitIds = [];
    if (!lengthListEl) return;
    Array.prototype.forEach.call(lengthListEl.querySelectorAll('.launch-notify__length-option'), function (el) {
      el.parentNode.removeChild(el);
    });
    lengthListEl.hidden = true;
  }

  function syncOptionCheckedClass(input) {
    var option = input && input.closest ? input.closest('.launch-notify__length-option') : null;
    if (option) option.classList.toggle('is-checked', !!input.checked);
  }

  function syncSubmitEnabled() {
    if (lengthListEl) {
      Array.prototype.forEach.call(lengthListEl.querySelectorAll('input[type="checkbox"]'), syncOptionCheckedClass);
    }
    if (!submitBtn || succeeded || submitting) return;
    if (!listIsVisible()) {
      submitBtn.disabled = false;
      submitBtn.classList.remove('is-selection-disabled');
      return;
    }
    var any = selectedVariantIds().length > 0;
    submitBtn.disabled = !any;
    submitBtn.classList.toggle('is-selection-disabled', !any);
    if (!any) showError('Select at least one length.');
    else if (errorEl && errorEl.textContent === 'Select at least one length.') showError('');
  }

  function renderLengthList() {
    clearLengthList();
    var product = getProduct();
    var groups = soldOutLengths(product, context.mode);
    if (groups.length === 1) {
      implicitIds = groups[0].ids.slice();
    } else if (groups.length === 0) {
      implicitIds = context.variantIds.slice();
      if (!implicitIds.length && product) {
        implicitIds = (product.variants || [])
          .filter(function (v) { return context.mode === 'coming_soon' || !v.available; })
          .map(function (v) { return String(v.id); });
      }
    }
    if (groups.length <= 1 || !lengthListEl) {
      syncSubmitEnabled();
      return;
    }
    var scoped = context.variantIds.length > 0;
    groups.forEach(function (group, index) {
      var option = document.createElement('label');
      option.className = 'launch-notify__length-option';
      var input = document.createElement('input');
      input.className = 'launch-notify__length-input';
      input.type = 'checkbox';
      input.name = 'launch-notify-length';
      input.value = group.ids.join(',');
      input.checked = scoped ? isTriggerLength(group) : true;
      input.id = 'LaunchNotifyLength-' + index;
      if (input.checked) option.classList.add('is-checked');
      var box = document.createElement('span');
      box.className = 'launch-notify__length-box';
      box.setAttribute('aria-hidden', 'true');
      var text = document.createElement('span');
      text.className = 'launch-notify__length-text';
      text.textContent = group.label;
      option.appendChild(input);
      option.appendChild(box);
      option.appendChild(text);
      lengthListEl.appendChild(option);
    });
    lengthListEl.hidden = false;
    syncSubmitEnabled();
  }

  function applyThumb() {
    if (!thumbEl) return;
    var featured = document.querySelector('[id^="FeaturedImage-"]');
    var src = featured && (featured.currentSrc || featured.src);
    if (!src && context.product && context.product.featured_image) {
      src = context.product.featured_image;
    }
    if (src) {
      thumbEl.src = src;
      thumbEl.alt = context.title || '';
      thumbEl.hidden = false;
    } else {
      thumbEl.removeAttribute('src');
      thumbEl.alt = '';
      thumbEl.hidden = true;
    }
  }

  function applyCopy() {
    var pack = copyFor(context.mode);
    var product = getProduct();
    var groups = soldOutLengths(product, context.mode);
    var listVisible = listIsVisible();
    var singleLabel = '';
    if (groups.length === 1) {
      singleLabel = groups[0].label;
    } else if (!listVisible) {
      singleLabel = context.lengthLabel || scopedLengthLabel(product, context.variantIds);
    }
    if (eyebrowEl) eyebrowEl.textContent = pack.eyebrow;
    if (titleEl) {
      if (listVisible) {
        titleEl.textContent = COPY.restock.title;
      } else if (singleLabel) {
        titleEl.textContent = 'Notify me when ' + singleLabel + ' is back';
      } else {
        titleEl.textContent = pack.title;
      }
    }
    if (copyEl) copyEl.innerHTML = buildCopyHtml(pack, product);
    if (successTextEl) successTextEl.textContent = pack.success;
    applyThumb();
  }

  function allSettled(promises) {
    if (Promise.allSettled) return Promise.allSettled(promises);
    return Promise.all(promises.map(function (p) {
      return Promise.resolve(p).then(
        function (value) { return { status: 'fulfilled', value: value }; },
        function (reason) { return { status: 'rejected', reason: reason }; }
      );
    }));
  }

  function open(opts) {
    var trigger = opts && opts.trigger;
    var variantIds = parseVariantIds(opts, trigger);
    context = {
      handle: (opts && opts.handle) || '',
      title: (opts && opts.title) || '',
      url: (opts && opts.url) || window.location.href,
      mode: (opts && opts.mode) === 'coming_soon' ? 'coming_soon' : 'restock',
      product: (opts && opts.product) || productFromTrigger(trigger) || null,
      variantIds: variantIds,
      lengthLabel: (opts && opts.lengthLabel) || (trigger && trigger.getAttribute('data-launch-length')) || ''
    };
    resetForm();
    renderLengthList();
    applyCopy();
    if (!configured()) {
      showError('Waitlist isn’t configured yet.');
    }
    setOpen(true);
  }

  function close() {
    setOpen(false);
  }

  function scheduleClose() {
    clearCloseTimers();
    closeTimer = setTimeout(function () {
      root.classList.add('is-leaving');
      fadeTimer = setTimeout(function () {
        close();
      }, FADE_MS);
    }, CLOSE_MS);
  }

  function markSubscribed() {
    succeeded = true;
    if (nameInput) nameInput.disabled = true;
    if (emailInput) emailInput.disabled = true;
    if (successEl) successEl.hidden = false;
    if (submitBtn) {
      submitBtn.hidden = false;
      submitBtn.disabled = true;
      submitBtn.classList.add('is-subscribed');
      submitBtn.textContent = SUCCESS_LABEL;
    }
    scheduleClose();
  }

  function subscribeOne(email, catalogId) {
    var payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          channels: ['EMAIL'],
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email
              }
            }
          }
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: catalogId
            }
          }
        }
      }
    };

    return fetch(
      'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' +
        encodeURIComponent(companyId),
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          revision: '2026-07-15'
        },
        body: JSON.stringify(payload)
      }
    ).then(function (res) {
      if (res.ok || res.status === 202) return res;
      return res.text().then(function (text) {
        throw new Error(text || ('Klaviyo error ' + res.status));
      });
    });
  }

  function subscribe(email) {
    if (listIsVisible() && !selectedVariantIds().length) {
      return Promise.reject(new Error('no_selection'));
    }
    var ids = unavailableCatalogIds();
    if (!ids.length) {
      return Promise.reject(new Error('no_variants'));
    }
    return allSettled(ids.map(function (id) {
      return subscribeOne(email, id);
    })).then(function (results) {
      var anyOk = results.some(function (result) {
        return result.status === 'fulfilled';
      });
      if (!anyOk) throw new Error('all_failed');
      return ids;
    });
  }

  document.addEventListener('click', function (evt) {
    var trigger = evt.target.closest('[data-launch-notify]');
    if (trigger) {
      evt.preventDefault();
      open({
        handle: trigger.getAttribute('data-launch-handle') || '',
        title: trigger.getAttribute('data-launch-title') || '',
        url: trigger.getAttribute('data-launch-url') || window.location.href,
        mode: trigger.getAttribute('data-launch-mode') || 'restock',
        trigger: trigger,
        product: productFromTrigger(trigger),
        variantId: trigger.getAttribute('data-launch-variant') || undefined,
        lengthLabel: trigger.getAttribute('data-launch-length') || ''
      });
      return;
    }
    if (evt.target.closest('[data-launch-notify-close]')) {
      evt.preventDefault();
      close();
    }
  });

  document.addEventListener('keydown', function (evt) {
    if (evt.key === 'Escape' && root.classList.contains('is-open')) close();
    if (evt.key !== 'Enter' && evt.key !== ' ') return;
    var trigger = evt.target.closest('[data-launch-notify][role="button"]');
    if (!trigger || root.contains(trigger)) return;
    evt.preventDefault();
    trigger.click();
  });

  if (lengthListEl) {
    lengthListEl.addEventListener('change', function (evt) {
      if (evt.target && evt.target.type === 'checkbox') syncSubmitEnabled();
    });
  }

  if (form) {
    form.addEventListener('submit', function (evt) {
      evt.preventDefault();
      if (submitting || succeeded) return;
      showError('');
      if (!configured()) {
        showError('Waitlist isn’t configured yet.');
        return;
      }
      var name = nameInput ? nameInput.value.trim() : '';
      var email = emailInput ? emailInput.value.trim() : '';
      if (!name || !email) {
        showError('Please enter your name and email.');
        return;
      }
      if (listIsVisible() && !selectedVariantIds().length) {
        showError('Select at least one length.');
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.classList.add('is-selection-disabled');
        }
        return;
      }
      submitting = true;
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.classList.remove('is-selection-disabled');
      }
      subscribe(email)
        .then(function () {
          markSubscribed();
        })
        .catch(function (err) {
          if (err && err.message === 'no_selection') {
            showError('Select at least one length.');
            syncSubmitEnabled();
            return;
          }
          showError('Something went wrong. Please try again.');
          if (submitBtn) submitBtn.disabled = false;
        })
        .then(function () {
          submitting = false;
          if (!succeeded) syncSubmitEnabled();
        });
    });
  }

  window.SHHLaunchNotify = { open: open, close: close };
})();
